const errorPrefix = 'errors.formFields.';

const jpPostcode = (value) => {
  const pattern = /^[0-9]{7}$/;

  if (!(pattern.test(value))) {
    return `${errorPrefix}japanPostalCode`;
  }
};

export default jpPostcode;
